export const quickLinks = [
   {
      id: 1,
      link: "About us",
      path: "/about"
   },
   {
      id: 2,
      link: "Contact us",
      path: "/contact"
   },
   {
      id: 3,
      link: "Careers",
      path: "*"
   },
   {
      id: 4,
      link: "News & Events",
      path: "/blogs"
   },
   {
      id: 5,
      link: "Client Stories",
      path: "*"
   },
];

export const usefulLinks = [
   {
      id: 1,
      link: "Advertise",
      path: "*"
   },
   {
      id: 2,
      link: "Sitemap",
      path: "*"
   },
   {
      id: 3,
      link: "Terms of Use",
      path: "*"
   },
   {
      id: 4,
      link: "Privacy Policy",
      path: "*"
   },
   {
      id: 5,
      link: "Copyright Policy",
      path: "*"
   },
];